export const fetchVocab = {
  pathname: () => '/api/v4/campaign/vocab',
}

export const fetchCampaign = {
  pathname: (id) => `/api/v4/campaign/${id}`
}

export const fetchTopCampaign = {
  pathname: () => '/api/v4/campaign/most-active',
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: (body) => JSON.stringify(body)
}

export const fetchCampaignByEndpoint = {
  pathname: ({ endpoint }) => `/api/v4/campaign/${endpoint}`,
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: ({ body }) => JSON.stringify(body)
}

export const fetchCampaignReports = {
  pathname: id => `/api/v4/campaign/${id}/reports`,
}

export const fetchCampaignTimeline = {
  pathname: (id) => `/api/v4/campaign/${id}/timeline`
}

export const fetchAttackPatterns = {
  pathname: (id) => `/api/v4/campaign/${id}/attack-pattern`
}
